// FILECONTENT_START src/common/components/Calendar/CalendarToolbar.tsx
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  Box,
  BoxProps,
  CircularProgress,
  styled,
  Typography,
  useTheme,
} from "@mui/material";
import I18n from "i18n-js";
import { Moment } from "moment";
import { Fragment, ReactNode } from "react";

import { enumToOptions } from "./../../modules/helpers";
import Button, { ButtonProps } from "./../Button";
import Spacer from "./../Spacer";

import { NAVIGATE, VIEWS } from "./calendarApi";

const Container = styled(Box)`
  flex: 1;
  display: flex;
`;

const Toolbar = styled(Box)`
  flex: 1;
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  position: relative;
`;

function CalendarButton(props: ButtonProps) {
  return (
    <Button
      {...props}
      /*backgroundStyle={{
        paddingVertical: 8,
        paddingHorizontal: 12,
        minWidth: 26,
      }}*/
    />
  );
}

function NavigateButton({ ...props }: ButtonProps) {
  return (
    <Button
      {...props}
      /*backgroundStyle={[
        {
          paddingVertical: 8,
          paddingHorizontal: 8,
          minWidth: 40,
          minHeight: 40,
        },
        backgroundStyle,
      ]}*/
    />
  );
}

export interface CalendarToolbarProps {
  label?: string | null;
  view: VIEWS;
  views: VIEWS[];
  onView: Function;
  onNavigate: Function;
  buttons?: any[] | ReactNode;
  customToolbar: any;
  loading?: boolean;
  showRefreshButton?: boolean;
  refresh?: Function;
  date?: Moment;
  containerStyle?: BoxProps["style"];
}

export default function CalendarToolbar({
  label,
  view,
  views,
  onView,
  onNavigate,
  buttons,
  customToolbar,
  loading,
  refresh,
  containerStyle,
  showRefreshButton = true,
}: CalendarToolbarProps) {
  const theme = useTheme();
  const viewOptions = enumToOptions(VIEWS, "CALNDAR.views");
  return (
    <Container style={containerStyle}>
      <Toolbar style={{ justifyContent: "space-between" }}>
        <NavigateButton
          startIcon={<ChevronLeftIcon />}
          onClick={() => onNavigate(NAVIGATE.PREVIOUS)}
        />
        <Spacer w={0.5} />
        <Typography variant="subtitle2">{label}</Typography>
        <Spacer w={0.5} />
        <NavigateButton
          endIcon={<ChevronRightIcon />}
          onClick={() => onNavigate(NAVIGATE.NEXT)}
        />
      </Toolbar>
      <Spacer h={1} />
      <Toolbar>
        {views.map((v, index) => {
          return (
            <Fragment key={index}>
              <CalendarButton
                variant={v === view ? "contained" : "outlined"}
                onClick={() => onView(v)}
                title={I18n.t(`Calendar.views.${v}`)}
              />
              {views.length - 1 > index && <Spacer w={0.5} />}
            </Fragment>
          );
        })}
        <Spacer right />
        {buttons && !Array.isArray(buttons) && buttons}
        {buttons &&
          Array.isArray(buttons) &&
          buttons.map((button, index) => {
            return (
              <Fragment key={index}>
                <CalendarButton
                  onClick={button.onClick}
                  variant="outlined"
                  title={button.title}
                />
                {buttons.length - 1 > index && <Spacer w={0.5} />}
              </Fragment>
            );
          })}
        {showRefreshButton && (
          <>
            <Spacer w={0.5} />
            <NavigateButton
              /*backgroundStyle={{
                backgroundColor: "transparent",
                minWidth: 46,
                minHeight: 46,
              }}*/
              //titleColor="secondary"
              startIcon={
                loading ? (
                  <CircularProgress size={27} color="secondary" />
                ) : (
                  <RefreshIcon />
                )
              }
              disabled={loading}
              onClick={refresh ? () => refresh() : undefined}
            />
          </>
        )}
      </Toolbar>
      {customToolbar}
    </Container>
  );
}

// FILECONTENT_END src/common/components/Calendar/CalendarToolbar.tsx